export default __webpack_public_path__ + "static/media/zoom-out.a79afa37.svg";